import { RouteComponentProps, withRouter } from "react-router-dom";
import { ApplicationState } from "../../../store";
import { PresentationMode } from "../../project/PresentationMode";
import { connect } from "react-redux";
import { PPMFeatures, Subscription } from "../../../store/Tenant";
import { EntityType } from "../../../entities/common";
import React from "react";

type StateProps = {
    subscription: Subscription;
    url?: string;
}

type Props = StateProps & RouteComponentProps<{ id: string }>;

const TasksPresentationMode = (props: React.PropsWithChildren<Props>) => {
    const { url, subscription, children } = props;
    const [isEnabled, setIsEnabled] = React.useState<boolean>(false);

    const isForce = !!props.location.state?.presentationMode;
    const isFeatureEnabled = Subscription.containsAny(subscription, [PPMFeatures.PresentationMode, PPMFeatures.PresentationModeUltra]);

    return <>
        {isFeatureEnabled && (isEnabled || isForce)
            ? <PresentationMode
                {...props}
                entityType={EntityType.Project}
                url={url}
                isForce 
                setIsEnabled={setIsEnabled} />
            : children
        }
    </>
}

function mapStateToProps(state: ApplicationState, ownProps: RouteComponentProps<{ id: string }>): StateProps {
    return {
        url: state.tenant.presentationModeSettings!.project,
        subscription: state.tenant.subscription,
    };
}

export default withRouter<React.PropsWithChildren<{}>>(connect(mapStateToProps)(TasksPresentationMode))